import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { SearchProceduresResult } from 'ts-types/api.types';
import styled from 'styled-components';
import { Table } from 'semantic-ui-react';
import LoaderComponent from 'components/LoaderComponent';

const ScrollableTableWrapper = styled.div`
  height: 290px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  border: 1px solid rgba(34,36,38,.15);
  box-shadow: none;
  border-radius: .28571429rem;

  & .ui.table {
    border: none;
  }

  & .ui.table thead tr:first-child > th {
    position: sticky !important;
    top: 0;
    z-index: 2;
    background: #fff;
  }

  & .ui.table tbody tr:last-child > td {
      border-bottom: 1px solid rgba(34,36,38,.15)
  }
`;

interface Props extends MessageSourceProps {
  proceduresLoading: boolean,
  onSelectProcedure: (entry: SearchProceduresResult) => void,
  foundProcedures: Array<SearchProceduresResult>,
  markProcedure: (procedureId?: number) => void,
  selectedProcedure?: number
}

interface State {
}

class SearchProceduresTableSegment extends Component<Props, State> {

  shouldComponentUpdate({proceduresLoading: nextProceduresLoading, foundProcedures: nextProcedures, selectedProcedure: nextSelectedProcedure}: Readonly<Props>,
                        nextState: Readonly<State>,
                        nextContext: any): boolean {

    const {proceduresLoading, foundProcedures, selectedProcedure} = this.props;

    if (nextSelectedProcedure != selectedProcedure
        || nextProceduresLoading != proceduresLoading
        || nextProcedures.length != foundProcedures.length) {

      if (nextProceduresLoading != proceduresLoading) {
        this.setState({
          selectedProcedure: -1
        });
      }

      return true;
    }

    return false;
  }

  render(): React.ReactNode {

    const {getMessage, proceduresLoading} = this.props;

    return (
        <ScrollableTableWrapper>
          <Table celled selectable size='small'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell verticalAlign={"middle"}
                                  key={1}>{getMessage("code")}</Table.HeaderCell>
                <Table.HeaderCell verticalAlign={"middle"}
                                  key={2}>{getMessage("procedure.internalDescription")}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.renderTableBody()}
              {proceduresLoading && (
                  <Table.Row>
                    <Table.Cell>
                      <LoaderComponent
                          message={`${getMessage("loading")} ${getMessage("procedures").toLowerCase()}`}
                          dimmerProps={{active: true, inverted: false}}
                      />
                    </Table.Cell>
                  </Table.Row>
              )}
            </Table.Body>
          </Table>
        </ScrollableTableWrapper>
    );
  }

  renderTableBody = (): React.ReactNode => {

    const {foundProcedures, onSelectProcedure, selectedProcedure, markProcedure, getMessage} = this.props;

    const rows = foundProcedures.map((procedure, index) => {
      return (
          <Table.Row
              key={index}
              onClick={() => markProcedure(procedure.id)}
              onDoubleClick={() => onSelectProcedure(procedure)}
              active={procedure.id == selectedProcedure}
          >
            <Table.Cell>{procedure.code}</Table.Cell>
            <Table.Cell>{getMessage(procedure.description!)}</Table.Cell>
          </Table.Row>
      )
    });

    return (
        <React.Fragment>
          {!!rows ? rows : <Table.Row/>}
        </React.Fragment>
    )
  };

}

export default withMessages(SearchProceduresTableSegment);
